import useJuryController from '@admin/api/useJuryController'
import MainContainer from '@blocks/MainContainer'
import Resource from '@components/modules/Resource'
import useAuth from '@hooks/useAuth'
import useTitle from '@hooks/useTitle'
import useMainTemplate from '@templates/Main/hooks/useMainTemplate'
import React from 'react'
import JuryForm from './components/JuryForm'
import columns from './config/columns'
import { Options } from '@modules/Table/types'

export default function JuriesPage() {
    const controller = useJuryController()

    useTitle("Juries")
    useMainTemplate({ category: "juries" })

    const { loginAsUser } = useAuth()
    const actions: Options<Interfaces.Jury.Includes<"country">>["actions"] = [
        { label: "Visit", action: row => loginAsUser(row.original.id) }
    ]

    return (
        <MainContainer heading="Juries">
            <Resource
                cache="admin:juries"
                form={JuryForm}
                label="jury"
                controller={controller}
                columns={columns}
                actions={actions} />
        </MainContainer>
        
    )
}